'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendConsentToProcess = sendConsentToProcess;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _wrappedPortalIdParser = require('../../utils/wrappedPortalIdParser');

var _wrappedPortalIdParser2 = _interopRequireDefault(_wrappedPortalIdParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_ENDPOINT = 'livechat/v1/privacy/consentToProcess';

function sendConsentToProcess(_ref) {
  var sessionId = _ref.sessionId,
      welcomeMessageId = _ref.welcomeMessageId;

  return _noAuthApiClient2.default.put(API_ENDPOINT, {
    query: {
      sessionId: sessionId,
      welcomeMessageId: welcomeMessageId,
      portalId: (0, _wrappedPortalIdParser2.default)('sendConsentToProcess client')
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/gdpr/client/ConsentToProcessClient.js
// module id = 1065
// module chunks = 2 3